import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AdminPageHeader, Form, AdminFormAction } from '@ui';
import {
  OpoForm,
  DEFAULT_OPO_VALUES,
  useOpoFormCreateSchema,
  NewOpoCreateForm,
} from '@lp/features/admin/forms/OPOForm';
import { useAuthContext } from '@lp/core/auth';
import { useCreateOpoMutation } from '@/queries/opo';
import { retrieveUnifiedError } from '@/api/utils';
import { AdminPermissions } from '@/permissions';
import { convertToIanaTimezone } from '@/utils/helpers';

export const OpoCreate = () => {
  const navigate = useNavigate();
  const { mutateAsync } = useCreateOpoMutation();
  const { checkPermission } = useAuthContext();

  const hasOpoCreatePermissions = checkPermission(AdminPermissions.OpoCreate);
  const { schema, isLoading: isGeoDataLoading } = useOpoFormCreateSchema();

  const handleBackToList = () => {
    navigate('/admin/opos/locations');
  };

  const handleSubmit = async (data: NewOpoCreateForm) => {
    try {
      await mutateAsync({
        name: data.name,
        code: data.code,
        location: {
          timezone: data.timezoneIANA || convertToIanaTimezone(data.timezone),
          addressLine: data.addressLine,
          city: data.city,
          state: data.state,
          postalCode: data.postalCode,
          country: data.country,
          longitude: data.longitude,
          latitude: data.latitude,
        },
      });

      toast.success(`OPO created successfully.`);

      handleBackToList();
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (isGeoDataLoading) return null;

  return (
    <Form<NewOpoCreateForm> defaultValues={DEFAULT_OPO_VALUES} schema={schema} onSubmit={handleSubmit}>
      <div className="flex flex-col gap-9">
        <AdminPageHeader title="Create New OPO" backToListLink="/admin/opos/locations">
          <AdminFormAction
            type="create"
            handleClick={handleBackToList}
            hasCreatePermissions={hasOpoCreatePermissions}
          />
        </AdminPageHeader>
        <OpoForm isReadOnly={!hasOpoCreatePermissions} />
      </div>
    </Form>
  );
};
